export default __webpack_public_path__ + "3e4efc690893813d055a761a0ccdc606.svg";